<template>
  <div v-if="activities && activities.length" class="activity-list-container">
    <h6 class="fw-bold text-secondary mb-3">
      <i class="fas fa-list-ul me-2"></i> {{ title }} ({{ activities.length }} hoạt động)
    </h6>
    <ul class="list-unstyled activity-ul">
      <li
        v-for="(activity, index) in activities"
        :key="activity.id || index"
        class="activity-card mb-3 p-3 border rounded shadow-sm bg-light"
      >
        <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
          <div>
            <span class="activity-index fw-bold text-primary me-2">#{{ index + 1 }}</span>
            <span class="activity-name fw-bold text-dark font-size-15">{{
              activity.name || "Hoạt động chưa đặt tên"
            }}</span>
          </div>
          
          <div class="d-flex align-items-center gap-2">
            <span class="badge bg-primary-subtle text-primary py-1.5 px-2">
              <i class="far fa-clock me-1"></i>
              {{ activity.gioBatDau || "?" }} - {{ activity.gioKetThuc || "?" }}
            </span>
            <a
              v-if="activity.diaChi"
              :href="getGoogleMapsLink(activity)"
              target="_blank"
              class="btn btn-xs btn-outline-info d-inline-flex align-items-center py-1 px-2"
              style="font-size: 11px;"
            >
              <i class="fas fa-map-marker-alt me-1"></i> Bản đồ
            </a>
          </div>
        </div>

        <!-- Meta fields: Chu tri, Tham muu, Dai bieu, Phoi hop, Qui mo, Hinh thuc, Y tuong, File -->
        <div class="row row-cols-1 row-cols-md-2 g-2 mt-1 small text-muted border-top pt-2">
          <div v-if="activity.diaChi" class="col">
            <span class="fw-semibold text-secondary">Địa điểm:</span> {{ activity.diaChi }}
          </div>
          <div v-if="activity.chuTri" class="col">
            <span class="fw-semibold text-secondary">Chủ trì:</span> {{ activity.chuTri }}
          </div>
          <div v-if="activity.thamMuu" class="col">
            <span class="fw-semibold text-secondary">Tham mưu:</span> {{ activity.thamMuu }}
          </div>
          <div v-if="activity.daiBieu" class="col">
            <span class="fw-semibold text-secondary">Đại biểu:</span> {{ activity.daiBieu }}
          </div>
          <div v-if="activity.phoiHop" class="col">
            <span class="fw-semibold text-secondary">Phối hợp:</span> {{ activity.phoiHop }}
          </div>
          <div v-if="activity.quiMo" class="col">
            <span class="fw-semibold text-secondary">Quy mô:</span> {{ activity.quiMo }}
          </div>
          <div v-if="activity.yTuong" class="col">
            <span class="fw-semibold text-secondary">Ý tưởng:</span> {{ activity.yTuong }}
          </div>
          <div v-if="activity.hinhThuc" class="col-12 mt-1 mb-1">
            <span class="fw-semibold text-secondary">Hình thức:</span>
            <div class="ck-content mt-1 p-2 border rounded bg-white text-dark font-size-13 text-left" v-html="activity.hinhThuc"></div>
          </div>
          <div v-if="activity.file && activity.file.fileId" class="col">
            <span class="fw-semibold text-secondary">Tài liệu:</span>
            <a :href="getFileUrl(activity.file)" target="_blank" class="text-success fw-bold ms-1">
              <i class="fas fa-paperclip me-1"></i> {{ activity.file.fileName }}
            </a>
          </div>
        </div>

        <!-- Detail contents (noiDungs) -->
        <div v-if="activity.noiDungs && activity.noiDungs.length" class="mt-2 border-top pt-2">
          <div class="fw-semibold text-secondary small mb-1">Nội dung chi tiết:</div>
          <ul class="list-unstyled ps-0 mb-0">
            <li v-for="(nd, ndIdx) in activity.noiDungs" :key="ndIdx" class="d-flex align-items-start gap-2 mb-1 small text-dark">
              <i :class="getIconClass(nd.icon)" class="text-success mt-1"></i>
              <span>{{ nd.text }}</span>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ActivityDetailList",
  props: {
    title: String,
    activities: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    hasLocationInfo(event) {
      return !!(
        event.latitude &&
        event.longitude &&
        event.latitude != 0 &&
        event.longitude != 0 &&
        event.latitude !== "0" &&
        event.longitude !== "0"
      );
    },

    getGoogleMapsLink(event) {
      if (this.hasLocationInfo(event)) {
        return `https://www.google.com/maps/search/?api=1&query=${event.latitude},${event.longitude}`;
      } else if (event.diaChi) {
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          event.diaChi
        )}`;
      }
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        "Đồng Tháp"
      )}`;
    },

    getIconClass(iconName) {
      const iconMap = {
        info: "fas fa-info-circle",
        chat: "fas fa-comments",
        star: "fas fa-star",
        music: "fas fa-music",
        calendar: "fas fa-calendar-check",
      };
      return iconMap[iconName] || "fas fa-dot-circle";
    },

    getFileUrl(file) {
      if (!file) return "";
      if (file.path && (file.path.startsWith("http://") || file.path.startsWith("https://"))) {
        return file.path;
      }
      return `${process.env.VUE_APP_API_URL || "/api/"}filesminio/view/${file.fileId || file.path || ""}`;
    },
  },
};
</script>

<style scoped>
.activity-list-container {
  padding: 15px;
  border: 1px solid rgba(187, 202, 186, 0.2);
  border-radius: 12px;
  background-color: #ffffff;
}
.activity-ul {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}
.activity-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
}
.activity-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05) !important;
  border-color: rgba(46, 125, 50, 0.2);
}
.activity-index {
  font-size: 14px;
}
.activity-name {
  color: #1b5e20;
}
</style>
